export const FETCHING_NEWS = 'FETCHING_NEWS'
export const ERROR_NEWS = 'ERROR_NEWS'
export const UPDATE_NEWS = 'UPDATE_NEWS'

export const FETCHING_GROUPS = 'FETCHING_GROUPS'
export const ERROR_GROUPS = 'ERROR_GROUPS'
export const UPDATE_GROUPS = 'UPDATE_GROUPS'

export const FETCHING_MATCHES = 'FETCHING_MATCHES'
export const ERROR_MATCHES = 'ERROR_MATCHES'
export const UPDATE_MATCHES = 'UPDATE_MATCHES'

export const FETCHING_CLIPS_AND_PLAYLISTS = 'FETCHING_CLIPS_AND_PLAYLISTS'
export const ERROR_CLIPS_AND_PLAYLISTS = 'ERROR_CLIPS_AND_PLAYLISTS'
export const UPDATE_CLIPS_AND_PLAYLISTS = 'UPDATE_CLIPS_AND_PLAYLISTS'

export const FETCHING_SCHEDULE = 'FETCHING_SCHEDULE'
export const ERROR_SCHEDULE = 'ERROR_SCHEDULE'
export const UPDATE_SCHEDULE = 'UPDATE_SCHEDULE'

export const FETCHING_MATCH_CLIPS = 'FETCHING_MATCH_CLIPS'
export const ERROR_MATCH_CLIPS = 'ERROR_MATCH_CLIPS'
export const UPDATE_MATCH_CLIPS = 'UPDATE_MATCH_CLIPS'

export const FETCHING_STATES = {
  READY: 'READY',
  FETCHING: 'FETCHING',
  ERROR: 'ERROR'
}
